import { observer } from 'mobx-react-lite';
import * as React from 'react';

interface RequiredAuthProps {
  title: string;
  children: ({
    isLoggedIn,
    forceLoginToProceedAction,
  }: {
    isLoggedIn: boolean;
    forceLoginToProceedAction: (action: () => void) => void;
  }) => JSX.Element | React.ReactNode;
  onUserAlreadyLoggedIn?: () => void;
  onLoginSuccess?: () => void;
  require?: boolean; // set to false to disable require authentication. Default is true.
}

export const RequiredAuthFake = observer((props: RequiredAuthProps) => {
  const { children } = props;

  const forceLoginToProceedAction = (action) => {
    action();
  };

  return <>{children({ isLoggedIn: true, forceLoginToProceedAction })}</>;
});
